import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { PlayersReport } from '@/models/players-report/players-report.model';

export default class GetPlayersReportRequest extends ApiResourceMethod<PlayersReport> {
  public perform(whitelabelSlug: string): Promise<PlayersReport> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/dashboard/playersReport`,
      },
      ({ data }: BaseResponse<PlayersReport>): PlayersReport => data,
    );
  }
}
